import { allCountries } from '@/modules/questionnaire/ui/components/phone-number-input/consts'

export const COUNTRY_OPTIONS = [...allCountries]
  .map(({ name, iso2 }) => {
    if (!name || !iso2) return null
    // Remove translations from country names
    const formattedName = name.includes('(')
      ? name.split('(').slice(0, -1).join('(').trim()
      : name

    return { name: formattedName, code: iso2 }
  })
  .filter(Boolean) as { name: string; code: string }[]

export const getCountryNameByCode = (code: string) => {
  const country = COUNTRY_OPTIONS.find((country) => country.code === code)

  return country?.name || ''
}
